const EmployeeRow = ({ employee, days, assignments }) => {
  return (
    <div className="planner-row">
      <div className="emp-col">
      <div className="name-avr">
        <div className="avatar">
          {employee.first_name?.[0]}
        </div>
        <div className="name-des">
          <strong>{employee.first_name} {employee.last_name}</strong>
          <small>{employee.designation}</small>
        </div>
        </div>
      </div>

      {days.map(d => {
        const dateKey = d.toISOString().split("T")[0];
        const shift = assignments.find(a => a.date === dateKey);

        // Days without a manual change show the standing shift from the
        // employee record; a day changed via Assign shift / swap / copy week
        // is flagged, and keeps its shift if the standing shift is edited.
        const manual = !!shift?.is_manual;
        return (
          <div
            key={dateKey}
            className={`shift-cell ${shift ? "assigned" : ""} ${manual ? "manual" : ""}`}
            title={
              manual
                ? "Manually edited for this day — kept if the employee's default shift changes"
                : shift
                  ? "Default shift from the employee record"
                  : undefined
            }
          >
            {shift ? shift.shift_name : "—"}
          </div>
        );
      })}
    </div>
  );
};

export default EmployeeRow;
